import { render, staticRenderFns } from "./WelcomeExplanationPage.vue?vue&type=template&id=87cd9f26&scoped=true&"
import script from "./WelcomeExplanationPage.vue?vue&type=script&lang=js&"
export * from "./WelcomeExplanationPage.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeExplanationPage.vue?vue&type=style&index=0&id=87cd9f26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cd9f26",
  null
  
)

export default component.exports